export const DEMO_MODE = false;

